import { Box, Button, Dialog, DialogActions, Tab, Tabs, Typography } from '@material-ui/core'
import TaxPlanPicker from 'components/TaxPlanPicker/TaxPlanPicker'
import PurchaseOrderPicker from 'components/PurchaseOrderPicker/PurchaseOrderPicker'
import {
  FIELDS,
  getCustomerByIdentificationService,
  getSupplierByIdService,
  NEW_PATH,
  RESOURCES_PATH,
  SUPPLIER_PATH,
} from 'lib'
import React from 'react'
import { IDocument, IPurchaseOrderAccoutingInfo, ITaxPlan } from 'types'
import { useHistory } from 'react-router'

interface Props {
  open: boolean
  onClose: () => void
  supplierId?: number
  onApprove: (taxPlan?: ITaxPlan, purchaseOrder?: IPurchaseOrderAccoutingInfo) => void
  requirePo: boolean
  requireTaxPlan: boolean
  identification?: string
  purchaseOrder?: IPurchaseOrderAccoutingInfo
  withReimbursementTaxPlan: boolean
  puObservation: String[]
  document: IDocument
}

function TabPanel(props: any) {
  const { children, value, index, ...other } = props
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box p={1}>{children}</Box>}
    </div>
  )
}

const ApproveDocumentDialog = (props: Props) => {
  const {
    onClose,
    open,
    onApprove,
    requireTaxPlan,
    identification,
    withReimbursementTaxPlan,
    puObservation,
    document,
  } = props
  const [requirePo, setRequirePo] = React.useState<boolean>(props.requirePo)
  const [value, setValue] = React.useState(requirePo && requireTaxPlan ? 0 : requirePo ? 1 : 0)
  const [selectedTaxPlan, setSelectedTaxPlan] = React.useState<ITaxPlan | undefined>(undefined)
  const [supplierId, setSupplierId] = React.useState<number | undefined>(props.supplierId)
  const [selectedPurchaseOrder, setSelectedPurchaseOrder] = React.useState<
    IPurchaseOrderAccoutingInfo | undefined
  >(props.purchaseOrder ?? undefined)
  const history = useHistory()

  const handleChange = (_: any, newValue: number) => setValue(newValue)

  React.useEffect(() => {
    const init = async () => {
      if (document.companyRuc && !supplierId) {
        try {
          let result

          if (document.documentTypeId === 8) {
            result = await getCustomerByIdentificationService(document.companyRuc)
            setSupplierId(result.customerId)
          } else if (document.documentTypeId === 1) {
            result = await getSupplierByIdService(document.companyRuc)
            setSupplierId(result.supplierId)
          }
          //setRequirePo(result.requirePo)
        } catch (error) {}
      }
    }
    init()
  }, [supplierId, identification])

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl">
      <React.Fragment>
        {identification && !supplierId ? (
          <div
            style={{ width: '40vw', height: '40vh' }}
            className="w-full h-full flex flex-col px-16 justify-center items-center"
          >
            <Typography className="pb-8" variant="h5" color="textSecondary" align="center">
              {'No se encontro el proveedor'}
            </Typography>
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={() => history.push(`${RESOURCES_PATH}${SUPPLIER_PATH}${NEW_PATH}`)}
            >
              {'Registrar'}
            </Button>
          </div>
        ) : (
          <React.Fragment>
            {requireTaxPlan && (
              <TabPanel value={value} index={0}>
                <TaxPlanPicker
                  selected={selectedTaxPlan}
                  setSelected={setSelectedTaxPlan}
                  supplierId={supplierId}
                  withReimbursementTaxPlan={withReimbursementTaxPlan}
                />
              </TabPanel>
            )}

            <DialogActions>
              <Button
                size="small"
                color="primary"
                variant="contained"
                disabled={
                  requirePo && requireTaxPlan
                    ? !selectedPurchaseOrder && !selectedTaxPlan
                    : requirePo
                      ? !selectedPurchaseOrder
                      : requireTaxPlan
                        ? !selectedTaxPlan
                        : false
                }
                disableElevation
                onClick={() => {
                  onApprove(selectedTaxPlan, selectedPurchaseOrder)
                  onClose()
                }}
              >
                {'Aprobar'}
              </Button>
            </DialogActions>
          </React.Fragment>
        )}
      </React.Fragment>
    </Dialog>
  )
}

export default ApproveDocumentDialog
